module.exports = __webpack_public_path__ + "static/img/newsbannerone.33113fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsbannerone.png
// module id = h6mG
// module chunks = 45